import React, { useEffect } from 'react';
import { ConversationsList } from '../components/ConversationsList';
import { useConversations } from '../hooks/useConversations';
import { User } from '../types';

interface ConversationsPageProps {
  currentUser: User;
}

/**
 * VISTA: Página de lista de conversaciones
 * CORREGIDO: Sin bucles infinitos
 */
export const ConversationsPage: React.FC<ConversationsPageProps> = ({ currentUser }) => {
  const { conversations, isLoading, error, hasLoaded, loadConversations } = useConversations();

  // Cargar conversaciones SOLO una vez al montar
  useEffect(() => {
    if (!hasLoaded && !isLoading) {
      console.log('🚀 ConversationsPage montado - iniciando carga única');
      loadConversations(currentUser.id);
    }
  }, []); // SIN dependencias para evitar bucles

  if (isLoading) {
    return (
      <div className="max-w-sm mx-auto bg-white min-h-screen flex items-center justify-center">
        <div className="text-center p-8">
          <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-4 animate-pulse">
            <div className="w-6 h-6 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
          <p className="text-gray-600">Cargando conversaciones...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="max-w-sm mx-auto bg-white min-h-screen flex items-center justify-center">
        <div className="text-center p-8">
          <p className="text-red-600 mb-4">{error}</p>
          <button
            onClick={() => loadConversations(currentUser.id)}
            className="bg-blue-500 text-white px-4 py-2 rounded-lg"
          >
            Reintentar
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full h-full bg-white flex flex-col">
      <ConversationsList
        conversations={conversations}
        currentUser={currentUser}
      />
    </div>
  );
};